export default __webpack_public_path__ + "static/raw-logo-fancy-e070f3f67e21a5506493e895a5703a73.webp";